<div class="overlay" *ngIf="isLoading | async">
  <div class="spinner">
    <div class="spinner-part spinner-part1"></div>
    <div class="spinner-part spinner-part2"></div>
    <img src="/assets/images/motorbike.png" alt="Suzuki Bike" class="spinner-center">
  </div>
</div>
<div class="container-fluid pl-0">
  <div class="container-inner">
    <!-- [hidden]="isCreate || isEdit" -->
    <div [hidden]="isCreate || isEdit">

      <div class="header-container">
        <h2>Products</h2>
        <div class="button-container">
          <button mat-raised-button class="add-button" (click)="add()">Add Product</button>
        </div>
      </div>
      <div class="leads-table mb-3">
        <table mat-table [dataSource]="dataSource" matSort class="mat-table">

          <ng-container matColumnDef="SNo">
            <th mat-header-cell *matHeaderCellDef> S.No </th>
            <td mat-cell *matCellDef="let element; let i = index">
              {{ (paginatorRef.pageIndex * paginatorRef.pageSize) + (i + 1) }}
            </td>
          </ng-container>

          <ng-container matColumnDef="product_model">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Product Model</th>
            <td mat-cell *matCellDef="let element">
              {{ element.product_model?.model || '-' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="product_variant">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Product Variant</th>
            <td mat-cell *matCellDef="let element">
              {{ element.product_variant?.variant || '-' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="product_category">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Product Category</th>
            <td mat-cell *matCellDef="let element">
              {{ element.product_category?.product_category || '-' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="outlet">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Outlet</th>
            <td mat-cell *matCellDef="let element">
              <ng-container *ngIf="element.outlets && element.outlets.length > 0; else noOutlet">
                <ng-container *ngFor="let outlet of element.outlets; let last = last">
                  <span>{{ outlet.outlet_name || '-' }}</span>
                  <span *ngIf="!last">, </span>
                </ng-container>
              </ng-container>
              <ng-template #noOutlet>No product available</ng-template>
            </td>
          </ng-container>

          <ng-container matColumnDef="product_color">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Product Color</th>
            <td mat-cell *matCellDef="let element">
              {{ element.product_color?.color || '-' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let element"
              [ngClass]="element.status == 1 ? 'status_active' : 'status_inactive'">
              {{element.status ? 'Active' : 'In-Active'}}</td>
          </ng-container>

          <!-- Action Column -->
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef style="text-align: center;">Action</th>
            <td mat-cell *matCellDef="let element" style="text-align: center;">
              <img [src]="bucketurl + '/images/pen.png'" class="edit-pen" title="Edit" (click)="editData(element)">
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" style="text-align: center; padding: 20px 0;" colspan="8">No data found!</td>
          </tr>
        </table>

        <mat-paginator #paginatorRef [pageSizeOptions]="[10, 20]" showFirstLastButtons></mat-paginator>
      </div>
    </div>
    <ng-container *ngIf="isCreate || isEdit">
      <div class="header-container">
        <h2>Products</h2>
        <div class="button-container">
          <button mat-raised-button class="add-button" (click)="back()">Back to List</button>
        </div>
      </div>
      <form [formGroup]="productForm">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
            <div class="themeinput">
              <label>Product Category</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
              <select class="form-control" formControlName="product_category_id"  [attr.value]="productForm.get('product_category_id')?.value"
                [ngClass]="{ 'is-invalid': submitted && f['product_category_id'].errors }"
                (change)="onCategoryChange($event)">
                <option value="" disabled selected>Select Product Category</option>
                <option *ngFor="let data of categories" [value]="data.id">{{ data.product_category}}
                </option>
              </select>
              <div *ngIf="submitted && f['product_category_id'].errors" class="invalid-feedback">
                <div *ngIf="f['product_category_id'].errors['required']">
                  Product Category is required
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
            <div class="themeinput">
              <label>Product Model</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
              <select class="form-control" formControlName="product_model_id"
              [attr.value]="productForm.get('product_model_id')?.value"
                [ngClass]="{ 'is-invalid': submitted && f['product_model_id'].errors }"
                (change)="onModelChange($event)">
                <option value="" disabled selected>Select Product Model</option>
                <option *ngFor="let product of filteredProducts" id="{{product.id}}" [value]="product.id">{{
                  product.model }}</option>
              </select>
              <div *ngIf="submitted && f['product_model_id'].errors" class="invalid-feedback">
                <div *ngIf="f['product_model_id'].errors['required']">
                  Product Model is required
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
            <div class="themeinput">
              <label>Product Variant</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
              <select class="form-control" formControlName="variant_id"
              [attr.value]="productForm.get('variant_id')?.value"
                [ngClass]="{ 'is-invalid': submitted && f['variant_id'].errors }" (change)="onColorChange($event)">
                <option value="" disabled selected>Select Product Variant</option>
                <option *ngFor="let variant of filteredVariants" [value]="variant.id">{{ variant.variant }}</option>
              </select>
              <div *ngIf="submitted && f['variant_id'].errors" class="invalid-feedback">
                <div *ngIf="f['variant_id'].errors['required']">
                  Product Variant is required
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
            <div class="themeinput">
              <label>Dealer / Outlet</label><span style="color: red; font-size :15px">&nbsp;*</span>
              <ng-multiselect-dropdown [placeholder]="'Select Dealer / Outlet'" formControlName="outlet_id"
                class="form-control" [settings]="dropdownSettingsProCategory" [data]="dealers"
                [attr.value]="productForm.get('outlet_id')?.value"
                [ngClass]="{ 'is-invalid': submitted && f['outlet_id'].errors }">
              </ng-multiselect-dropdown>
              <div *ngIf="submitted && f['outlet_id'].errors" class="invalid-feedback">
                <div *ngIf="f['outlet_id'].errors['required']">Dealer / Outlet is required</div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
            <div class="themeinput">
              <label>Product Color</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
              <select class="form-control" formControlName="color_id"
              [attr.value]="productForm.get('color_id')?.value"
                [ngClass]="{ 'is-invalid': submitted && f['color_id'].errors }">
                <option value="" disabled selected>Select Product Color</option>
                <!-- <option *ngFor="let color of colors" [value]="color.id">{{ color.color }}</option> -->
                <option *ngFor="let color of colors" [value]="color.id">{{ color.color }}</option>
              </select>
              <div *ngIf="submitted && f['color_id'].errors" class="invalid-feedback">
                <div *ngIf="f['color_id'].errors['required']">
                  Product Color is required
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
            <div class="themeinput">
              <label>Status</label><span style="color: red; font-size :15px">&nbsp;*</span>
              <select name="" class="form-control" formControlName="status"
              [attr.value]="productForm.get('status')?.value"
                [ngClass]="{ 'is-invalid': submitted && f['status'].errors }">
                <option value="" disabled selected>--Select Status--</option>
                <option *ngFor="let data of statusList" [value]="data.id">{{ data.name }}</option>
              </select>
              <div *ngIf="submitted && f['status'].errors" class="invalid-feedback">
                <div *ngIf="f['status'].errors['required']">Status is required</div>
              </div>
            </div>
          </div>
          <div class="col-lg-12 mt-5">
            <div class="text-right-right">
              <button mat-raised-button *ngIf="isCreate" class="clear-button" (click)="clearForm()">Clear</button>
              <button *ngIf="isCreate" class="create-button ml-2" mat-raised-button
                (click)="createProduct()">Create</button>

              <button *ngIf="isEdit" class="create-button ml-2" mat-raised-button (click)="update()">Update</button>
            </div>
          </div>
        </div>
      </form>
    </ng-container>
  </div>
</div>